<template>
  <NText>{{
    $t('option.failedToDeliverQuantityContent', { quantity: props.quantity })
  }}</NText>
</template>

<script setup lang="ts">
interface TProps {
  quantity: number;
}

const props = defineProps<TProps>();
</script>
